<ng-container>
    <sigecom-content-container
        title="Editar Estado"
        [bottomGap]="1"
    >
        <div class="flex flex-row" buttons>
            <sigecom-button
                class="mr-1"
                (buttonClicked)="goToStatesList()"
                title="CONSULTAR ESTADOS"
                icon="list"
            />
        </div>

        <div content>
            <div class="text-sigecom-gray pb-4">
                <p>Campos indicados com asterisco (<span class="text-red-600">*</span>) são obrigatórios</p>
            </div>

            <form class="w-full" [formGroup]="statesPostForm">
                <div class="w-full grid grid-cols-2 gap-4">
                    <div class="col-span-2">
                        <sigecom-new-dropdown
                            label="País"
                            formControlName="paiNrId"
                            [options]="countryOptions?.content ?? []"
                            optionIdentify="paiNrId"
                            optionLabel="paiTxDescricaoPt"
                            [lastValidSelectedOption]="selectedCountry!"
                            paged
                            searchble
                            (pageChange)="loadOptionsCountry({page:$event,size:10})"
                            (searchChange)="loadOptionsCountry({page:0,size:10},$event)"
                            [totalPages]="countryOptions?.totalPages ?? 1"
                            [currentPage]="countryOptions?.number ?? 0"
                            [error]="messageErrorResolver.showErrorMessageForKey(statesPostForm,'paiNrId')"
                        /> 
                    </div>

                    <div class="col-span-1">
                        <sigecom-input-container 
                            label="Nome"
                            [isRequired]="true"
                            [errorMessage]="messageErrorResolver.showErrorMessageForKey(statesPostForm,'estTxDescricao')"
                        >
                            <input 
                            type="text" 
                            name="estTxDescricao" 
                            formControlName="estTxDescricao"
                            sigecom-input
                            required
                                  placeholder="Ex.: Descrição do estado"
                            />
                        </sigecom-input-container>
                    </div>
                    <div class="col-span-1">
                        <sigecom-input-container 
                            label="Sigla"
                            [isRequired]="true"
                            sigecom-input
                            [errorMessage]="messageErrorResolver.showErrorMessageForKey(statesPostForm,'estTxSigla')"
                        >
                            <input 
                            type="text" 
                            name="estTxSigla" 
                            formControlName="estTxSigla"
                            sigecom-input
                            required
                            placeholder="Ex.: SE "
                            min="2"
                            max="2"
                            />
                        </sigecom-input-container>
                    </div>
                </div>
              </form>
              <div class="flex mt-3 justify-end ">
                <div class="mr-3">
                    <sigecom-button 
                        title="Cancelar"
                        [outlined]="true"
                        type="danger"
                        (buttonClicked)="goToStatesList()"
                    >
                    </sigecom-button>
                </div>
                <div>
                    <sigecom-button 
                        title="Salvar Alterações"
                        [outlined]="true"
                        type="info"
                        [disabled]="!statesPostForm.valid"
                        (buttonClicked)="submitForm()"
                    >
                    </sigecom-button>
                </div>
            </div>
        </div>
    </sigecom-content-container>
</ng-container>bvbvb
